import React, { Component } from 'react';
import { clone } from 'lodash';

import { bemClasses } from '../../utils/bem';

import './styles.scss';

class Text extends Component {
  ALLOWED_MODIFIERS = [
    'blue',
    'orange',
    'red',
    'yellow',
    'green',
    'grey',
    'darkGrey',
    'lightGrey',
    'white',
    'large',
    'wrap',
    'centered',
    'block',
    'light',
    'standardWeight',
    'onClick',
    'small',
    'tiny',
    'inline',
    'darkGreyLighter',
    'extraLarge',
    'light-orange',
  ];

  componentClassNames = () => {
    let options = clone(this.props);
    if (this.props.color) {
      options[this.props.color] = true;
    }

    return bemClasses(
      'text',
      this.ALLOWED_MODIFIERS,
      options,
      this.props.className
    );
  };

  render = () => {
    return (
      <div className={this.componentClassNames()} onClick={this.props.onClick}>
        {this.props.children}
      </div>
    );
  };
}

export default Text;
